module.exports = __webpack_public_path__ + "img/instagram-challenge.e529281d.jpeg";